/**
 * fusion-admin/main.js — the Fusion Meals admin, admin.fusion-eat.com
 * (16 Oct 2026). A second site built from this project: the same meals
 * screens, API client and login as the Pizza Felice app, in its own frame.
 * Built with `vite build --mode fusion` (fusion-test for test); see vite.config.js.
 */
import { createApp } from "vue";
import { registerPlugins } from "@/plugins";
import FusionAdminApp from "./FusionAdminApp.vue";
import router from "./router.js";
import "vuetify/styles";
import { markTestTitle } from "@/utils/testSite.js";

const app = createApp(FusionAdminApp);
app.use(router);
registerPlugins(app);
markTestTitle(); // "[TEST] …" in the tab on the test site
app.mount("#app");
